/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommonState } from './common.reducer';

export const selectCommonState = createFeatureSelector<CommonState>('common');

export const selectPageType = createSelector(selectCommonState, (state) => state.pageType);
